@let outcome = outcomeSg();

<div class="atn-summit-allocation-graph-root-outcome">
  <div class="atn-summit-allocation-graph-root-outcome__header">
    <h4 class="atn-summit-allocation-graph-root-outcome__name">
      {{ outcome.name }}
    </h4>
    <i
      actions
      class="atn-icon atn-link atn-blue"
      (click)="
        onLinkClick({ entityId: outcome.entityId, recordId: outcome.id })
      "
    ></i>
  </div>

  <p class="atn-summit-allocation-graph-root-outcome__description">
    {{ outcome.description }}
  </p>
</div>
